var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-links"},[_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-positions',
      query: { company_id: _vm.company_id, sort: '-is_hot' }
    }}},[_c('p',[_vm._v("Positions")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-employees',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("Employees")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-texts',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("Texts")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-educations',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("Educations")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-locations',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("Locations")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-questions',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("Questions")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-history-companies',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("History Companies")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'company-meetings',
      query: { company_id: _vm.company_id }
    }}},[_c('p',[_vm._v("Meetings")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }